import {API} from '../API';

export class NoteService {

  async saveNote(contact, data) {
    return (await API.getConnection())
      .post(`contacts/${contact.id}/notes`, data)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }
}
